module.exports = __webpack_public_path__ + "img/us-rounded.c7ef7aee.png";